__turbopack_context__.v({
  "active": "iPOLlG_active",
  "archiveMenuItem": "iPOLlG_archiveMenuItem",
  "control": "iPOLlG_control",
  "filters": "iPOLlG_filters",
  "selector": "iPOLlG_selector",
  "typeContainer": "iPOLlG_typeContainer",
  "viewBy": "iPOLlG_viewBy",
});
